const BASE = '/tools/general/invoice-generator';

export function invoiceNewPath(query?: {
  customer?: string;
  duplicate?: string;
}): string {
  const params = new URLSearchParams();
  if (query?.customer) params.set('customer', query.customer);
  if (query?.duplicate) params.set('duplicate', query.duplicate);
  const q = params.toString();
  return q ? `${BASE}/new/?${q}` : `${BASE}/new/`;
}

export function invoiceViewPath(id: string): string {
  return `${BASE}/invoices/${encodeURIComponent(id)}/`;
}

export function invoiceEditPath(id: string): string {
  return `${BASE}/invoices/${encodeURIComponent(id)}/edit/`;
}

export function invoicesListPath(): string {
  return `${BASE}/`;
}

export function guestHistoryPath(): string {
  return `${BASE}/history/`;
}

export function guestHelpPath(): string {
  return `${BASE}/help/`;
}

export function guestGuidesPath(): string {
  return `${BASE}/guides/`;
}

/** Signed-in users → My Invoices (`/`); guests → History (`/history/`). */
export function historyHomePath(uid: string | null | undefined): string {
  return uid ? invoicesListPath() : guestHistoryPath();
}

/** Header logo always opens a new invoice editor. */
export function logoHomePath(_uid?: string | null): string {
  return invoiceNewPath();
}

export function thankYouPath(id: string): string {
  return `${BASE}/thank-you/?id=${encodeURIComponent(id)}`;
}

export function invoiceSendPath(id: string): string {
  return `${BASE}/invoices/${encodeURIComponent(id)}/send/`;
}
